import { ReadActionKey } from 'owa-outlook-service-options';

export const menuKeysInOrder: ReadActionKey[] = [
    'Reply',
    'ReplyAll',
    'Forward',
    'OtherReplyActions',
    '-',
    'Delete',
    'MarkReadUnread',
    'FlagUnflag',
    'AddToProjectSpace',
    'AddToSafeSenders',
    'MessageSafety',
    '-',
    'Print',
    'View',
    '-',
    'Addins',
    'AdvancedActions',
    'ToggleDarkMode',
    'ToggleAmp',
];
